export const PropertiesProfileMPITabsData = [
  { tab: 'sale' },
  { tab: 'lease' },
];
